import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import "./VtDisabledNotice.scss";
export default function VtDisabledNotice() {
  return /* @__PURE__ */ jsx("div", { className: "vtDisabledNotice", children: /* @__PURE__ */ jsxs("p", { children: [
    "The Virtual Terminal is not enabled for your account. Please reach out to our support team to request enabling this feature. You can reach our team at ",
    /* @__PURE__ */ jsx("a", { href: "mailto:Support@nex.io", children: "Support@nex.io" }),
    " or call ",
    /* @__PURE__ */ jsx("a", { href: "tel:+18772674324", children: "1-877-267-4324" }),
    "."
  ] }) });
}
